export default {
  eyebrow: 'Portal partnera',
  title: 'Konto',
  description: 'Szczegóły konta partnera.',
  page: {
    read_only_notice: 'Tylko do odczytu. Kliknij Edytuj, aby zmienić wartość.',
    editing_notice: 'Edycja — zmiany są widoczne dla zespołu i klientów.',
  },
  profile: {
    form: {
      name: {
        label: 'Nazwa partnera',
        hint: 'Nazwa prawna / podmiotu. Używana w dokumentach rozliczeniowych.',
      },
      display_name: {
        label: 'Nazwa wyświetlana dla klientów',
        hint: 'Etykieta „Powered by ___" widoczna dla klientów w restauracjach. Domyślnie przyjmuje nazwę partnera, jeśli pole jest puste.',
      },
      support_email: {
        label: 'E-mail kontaktowy',
        hint: 'Adres, pod którym FoodAmigos i klienci mogą się z Tobą skontaktować. E-mail logowania pozostaje bez zmian.',
      },
      invoicing_emails: {
        label: 'E-maile z fakturami',
        hint: 'Potwierdzenia dla faktur wystawionych na Ciebie są wysyłane na każdy z tych adresów. Pozostaw puste, aby użyć e-maila logowania.',
        placeholder: 'Twój e-mail logowania',
      },
    },
  },
  buttons: {
    edit: 'Edytuj',
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  toasts: {
    load_error: 'Nie można załadować szczegółów konta.',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
